import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

export const exportCampaignTotalTimeseriesRequestSchema = z.object({
  start_date: z.string().trim().min(1),
  end_date: z.string().trim().min(1),
});

export type ExportCampaignTotalTimeseriesRequest = z.infer<
  typeof exportCampaignTotalTimeseriesRequestSchema
>;

export async function ExportCampaignTotalTimeseries(
  campaignId: string,
  request: ExportCampaignTotalTimeseriesRequest,
  signal?: AbortSignal,
): Promise<string> {
  const parsedRequest = exportCampaignTotalTimeseriesRequestSchema.parse(request);
  const response = await socialApiClient.post(`campaigns/${campaignId}/exports/total-timeseries`, {
    json: parsedRequest,
    signal,
  });
  return await response.text();
}
